export const openSideNav = () => ({
  type: 'navigation/OPEN_SIDE_NAV',
});

export const closeSideNav = () => ({
  type: 'navigation/CLOSE_SIDE_NAV',
});
